document.addEventListener("DOMContentLoaded", () => {
  const sectionSelector = ".tuition-calculator-container";
  const innerSelector = ".tuition-calculator-inner";
  const formSelector = ".tuition-calculator-filters";
  const resultsSelector = ".tuition-calculator-results";
  const tableSelector = ".tuition-calculator-table";
  const noResultsSelector = ".tuition-calculator-no-results";

  // Start
  document.querySelectorAll(sectionSelector).forEach((section) => {
    const form = section?.querySelector(formSelector);
    const inner = section?.querySelector(innerSelector);
    const noResults = section?.querySelector(noResultsSelector);
    const results = section?.querySelector(resultsSelector);
    const tables = results?.querySelectorAll(tableSelector);

    if (!section || !results) return;

    // Helper to serialize form data, removing empty values
    function serializeForm(form, includeDisabled = false) {
      const data = new FormData(form);
      const params = new URLSearchParams();

      for (const [key, value] of data.entries()) {
        if (value !== null && value !== undefined && value !== "") {
          params.append("tuition-" + key, value);
        }
      }

      if (includeDisabled) {
        form.querySelectorAll("[name]:disabled").forEach((field) => {
          if (field.value !== "") {
            params.append("tuition-" + field.name, field.value);
          }
        });
      }

      return params.toString().replace(/%2C/gi, ",");
    }

    // Update what is displayed
    const updateState = (push = true) => {
      if (!form) return;

      let visibleRows = 0;

      const selects = form.querySelectorAll("select", 'input[type="hidden"]');

      let previousSelected = true;
      let previousValue = "";

      selects.forEach((select) => {
        let numAvailableOptions = 0;

        if (previousSelected || select.dataset.disabled) {
          select.disabled = false;
        } else {
          select.disabled = true;
          if (!select.dataset.disabled) {
            select.value = "";
          }
        }

        select.querySelectorAll("option").forEach((option) => {
          if (option.value == "") return;

          if (
            previousSelected &&
            (option.dataset.all == "1" ||
              option.dataset.previous
                .split(",")
                .map((v) => v.trim())
                .includes(previousValue))
          ) {
            option.disabled = false;
            numAvailableOptions++;
          } else {
            option.disabled = true;

            if (select.value == option.value) {
              select.value = "";
            }
          }
        });

        previousSelected = !!select.value;
        previousValue = select.value;
      });

      if (previousSelected) {
        const query = serializeForm(form);
        const url = window.location.pathname + (query ? "?" + query : "");
        if (push) {
          history.pushState({ query }, "", url);
        }

        inner.classList.remove("hidden");

        const params = new URLSearchParams(query);
        tables.forEach((table) => {
          let show = true;
          for (const [key, value] of params.entries()) {
            const dataKey = key.startsWith("tuition-") ? key.slice(8) : key;
            const compareValues = table.dataset[dataKey]?.split(',') ?? [];
            let hasValue = false;

            for (const compareValue of compareValues) {
              if (value && compareValue.trim() === value) {
                hasValue = true;
                break;
              }
            }

            if (!hasValue) {
              show = false;
              break;
            }
          }
          table.classList.toggle("selected", show);
          if (show) visibleRows++;
        });
      } else {
        inner.classList.add("hidden");
      }

      noResults.classList.toggle("hidden", visibleRows > 0);
    };

    // On form submit (e.g. pressing enter)
    form?.addEventListener("submit", function (e) {
      e.preventDefault();
      updateState(true);
    });

    section?.querySelectorAll("select").forEach((select) => {
      select.addEventListener("change", function (e) {
        updateState(true);
      });
    });

    // Handle browser navigation (back/forward)
    window.addEventListener("popstate", function () {
      loadFiltersFromUrl(window.location.href);
    });

    // Update the fields from the parameters in the url
    function loadFiltersFromUrl(url) {
      const urlObj = new URL(url, window.location.origin);
      const params = new URLSearchParams(urlObj.search);

      form.querySelectorAll("[data-type]").forEach((input) => {
        const type = input.dataset.type;
        const paramValue = params.get("tuition-" + type) || "";
        if (paramValue != "") {
          input.value = paramValue;
        }
      });

      updateState(false);
    }

    loadFiltersFromUrl(window.location.href);
  });
});

document.addEventListener("DOMContentLoaded", () => {
  const getRows = () =>
    document.querySelectorAll(".tuition-calculator-table-row");

  // Breakpoints
  let lastIsDesktop = window.matchMedia("(min-width: 960px)").matches;
  const isDesktop = () => window.matchMedia("(min-width: 960px)").matches;

  // Toggle row open/close
  document.addEventListener("click", (e) => {
    if (!e.target.closest(".tuition-calculator-table-row-toggle")) return;

    e.preventDefault();
    const row = e.target.closest(".tuition-calculator-table-row");
    if (row) {
      row.classList.toggle("is-open");
    }
  });

  // Remove .is-open on breakpoint change
  window.addEventListener("resize", () => {
    const currentDesktop = isDesktop();
    if (currentDesktop !== lastIsDesktop) {
      getRows().forEach((row) => row.classList.remove("is-open"));
      lastIsDesktop = currentDesktop;
    }
  });
});
